import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { JoinUsComponent } from './join-us/join-us.component';
import { NewsComponent } from './news/news.component';
import { TeamComponent } from "./team/team.component";
import { PublicationsComponent } from './publications/publications.component';
import { TeachingComponent } from './teaching/teaching.component';


const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'news',
    component: NewsComponent
  },
  {
    path: 'team',
    component: TeamComponent
  },
  {
    path: 'publications',
    component: PublicationsComponent
  },
  {
    path: 'teaching',
    component: TeachingComponent
  },
  {
    path: 'join-us',
    component: JoinUsComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
